import type { ContentIdea, IdeaPresentation } from '@mouja/domain/content-ideas';
import { Button } from '../../merchant/ui/primitives.js';
import { SavedIdeaCard } from './SavedIdeaCard.js';
import { firstIdeaCopy } from './firstIdeaCopy.js';
export function FirstIdeaOption({
  idea,
  presentation,
  language,
  index,
  discovery,
  selected,
  disabled,
  canAdjust,
  onSelect,
  onEvidence,
  onAdjust,
}: {
  idea: ContentIdea;
  presentation: IdeaPresentation | null;
  language: 'en' | 'ar';
  index: number;
  discovery: boolean;
  selected: boolean;
  disabled: boolean;
  canAdjust: boolean;
  onSelect: () => void;
  onEvidence: () => void;
  onAdjust: () => void;
}) {
  const c = firstIdeaCopy[language],
    item = presentation?.items.find((row) => row.ideaId === idea.id);
  const display = {
    concept: item?.concept ?? idea.angle,
    fit: item?.fit ?? idea.whyRelevant,
    treatment: item?.treatment ?? idea.creativeTreatment,
  };
  return (
    <SavedIdeaCard
      id={idea.id}
      title={idea.title}
      selected={selected}
      disabled={disabled}
      onSelect={onSelect}
    >
      {discovery && (
        <span className="mj-first-ordinal">{String(index + 1).padStart(2, '0')}</span>
      )}
      <h2 dir="auto" lang={idea.outputLocale}>
        {idea.title}
      </h2>
      <p dir="auto" lang={idea.outputLocale}>
        {display.concept}
      </p>
      <blockquote className="mj-first-hook">
        <small>{c.opening}</small>
        <span dir="auto" lang={idea.outputLocale}>
          {idea.hook}
        </span>
      </blockquote>
      {display.fit && (
        <p className="mj-first-fit">
          <strong>{c.fit}: </strong>
          <span dir="auto" lang={idea.outputLocale}>
            {display.fit}
          </span>
        </p>
      )}
      <span className="mj-first-basis">
        {idea.basis === 'TOPIC_BASED'
          ? c.topicBasis
          : idea.basis === 'BUSINESS_BASED'
            ? c.businessBasis
            : idea.basis === 'SAVED_REFERENCE'
              ? c.savedBasis
              : c.liveBasis}
      </span>
      {idea.limitations.some((r) => r.code === 'SEED_RETAINED_NOT_FULLY_DEVELOPED') && (
        <p className="mj-first-notice">{c.retained}</p>
      )}
      <div className="mj-first-card-actions">
        {(display.treatment || idea.objective) && (
          <details>
            <summary>{c.extra}</summary>
            {idea.objective && (
              <p>
                <strong>{c.objective}: </strong>
                <span dir="auto" lang={idea.outputLocale}>
                  {idea.objective}
                </span>
              </p>
            )}
            {display.treatment && (
              <p dir="auto" lang={idea.outputLocale}>
                {display.treatment}
              </p>
            )}
          </details>
        )}
        <Button variant="secondary" onClick={onEvidence}>
          {c.inspiration}
        </Button>
        {canAdjust && (
          <Button variant="secondary" onClick={onAdjust}>
            {c.adjust}
          </Button>
        )}
      </div>
    </SavedIdeaCard>
  );
}
